export const mapiHeaders = (orderingToken, mapiSessionID='', applicationID='') => ({
    Accept: 'application/json',
    'Session-ID': mapiSessionID,
    'Application-ID': applicationID,
    'Application-URL': window.location.href,
    Authorization: `Token ${orderingToken}`
})
